import BaseFormat from './base/_format';

const Format = global.Format = Object.assign({}, BaseFormat, {});

export default Format;
